import { setupAxios, getCvAccessToken } from '@carvana/core-auth';
import axios from 'axios';
import isEmpty from 'vanillas/isEmpty';
import { getVersionBase } from './shared';

const getAuthorization = () => {
  const token = getCvAccessToken();

  if (!token) {
    return '';
  }

  return `Bearer ${token}`;
};

export const getHeaders = () => {
  const header: {
    headers: {
      Authorization: string;
      'Content-Type'?: string;
    };
  } = {
    headers: {
      Authorization: getAuthorization()
    }
  };
  header.headers['Content-Type'] = 'application/json';

  return header;
};

const getTradesApiPathHelper = (
  controller: string,
  resource: string,
  token: string,
  version: number
) => {
  const optionalPath = !isEmpty(token) ? '/limited' : '';
  const baseApi = getVersionBase(version);
  const base = `${baseApi}/${controller}`;
  const withResource = `${base}${!isEmpty(resource) ? '/' : ''}${resource}`;
  return `${withResource}${optionalPath}`;
};

type Resource = {
  controller: string;
  resource: string;
  version: number;
};

export const buildUrl = (parts: Resource, token?: string) =>
  getTradesApiPathHelper(parts.controller, parts.resource, token || '', parts.version);

const authenticatedAxios = setupAxios(
  axios.create({ baseURL: `${process.env.CARVANA_APP_OFFER_API_URL}` }),
  {
    addBearerTokenToAllRequests: true
  }
);

export default authenticatedAxios;
